import { styled } from '@mui/material';
import { coreThemeColors } from '@youscience/theme';
import { CoreBox } from '@youscience/core';

export const sxStyles = {
  link: {
    color: coreThemeColors.secondary.main,
    textDecorationColor: coreThemeColors.secondary.main,
  },
};

export const StyledCardHeader = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignContent: 'flex-start',
  alignItems: 'stretch',
  justifyContent: 'space-between',
  gap: '1rem',

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const StyledCardHeaderTasks = styled(CoreBox)(() => ({
  display: 'flex',
  flexWrap: 'nowrap',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '0.5rem',
  width: '7.5rem',
}));

export const StyledCardHeaderInfo = styled(CoreBox)(() => ({
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'stretch',
  flexDirection: 'column',
  gap: '0.5rem',
}));

export const StyledCardHeaderInfoTitle = styled(CoreBox)(() => ({
  display: 'flex',
  alignContent: 'flex-start',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexDirection: 'row',
  padding: '0.5rem 0',
}));

export const StyledCardHeaderRemoveBtn = styled(CoreBox)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: '104px',
  height: '33px',
  padding: '0.75rem',
  borderRadius: '40px',
  border: `1px solid ${coreThemeColors.secondary.main}`,
  color: coreThemeColors.secondary.main,
  fontSize: '0.813rem',
  transition: 'background-color 0.5s',

  '&:hover': {
    cursor: 'pointer',
    backgroundColor: coreThemeColors.secondary.outlinedHoverBackground,
  },
}));

export const StyledCardHeaderInfoSubtitle = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  alignContent: 'flex-start',
  justifyContent: 'space-between',
  flexDirection: 'row',

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: '1rem',
  },
}));

export const StyledCardHeaderInfoSubtitleLeft = styled(CoreBox)(({ theme }) => ({
  display: 'flex',

  [theme.breakpoints.down('md')]: {
    gap: '1rem',
    flexDirection: 'column',
  },
}));

export const StyledCardHeaderInfoSubtitleRight = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  gap: '1rem',

  [theme.breakpoints.down('md')]: {
    gap: '1rem',
    flexDirection: 'column',
  },
}));

export const StyledCardHeaderInfoSubtitleItem = styled(CoreBox)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.25rem',

  '& > svg:first-of-type': {
    fill: coreThemeColors.secondary.main,
  },
}));
